var _defs, _path, _path2, _circle, _path3, _circle2, _circle3, _path4, _circle4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGamePieceHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "80mm",
    height: "80mm",
    viewBox: "0 0 226.7717 226.7717",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fc86bf;}.b{fill:#4c0237;}.c{fill:#961c6d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M113.5205,81.4643s13.7944-30.7888,47.1119-30.7888c27.89,0,47.1119,23.2618,47.1119,50.637,0,35.465-33.3323,65.0485-94.2238,107.2547-60.8917-42.2062-94.2237-71.79-94.2237-107.2547,0-27.3752,19.2216-50.637,47.1118-50.637C99.7261,50.6755,113.5205,81.4643,113.5205,81.4643Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M113.5209,210.7089a2.1348,2.1348,0,0,1-1.2193-.3817c-61.707-42.7708-95.1457-72.8116-95.1457-109.0142,0-30.0891,21.1742-52.78,49.2525-52.78,27.2812,0,42.11,20.0657,47.1125,28.4473,5.0029-8.3816,19.83-28.4473,47.1108-28.4473,28.08,0,49.2543,22.6906,49.2543,52.78,0,36.2026-33.4385,66.2434-95.1455,109.0142A2.1348,2.1348,0,0,1,113.5209,210.7089ZM66.4084,52.8169c-25.6374,0-44.969,20.8488-44.969,48.4961,0,34.087,32.3468,63.1553,92.0815,104.6472,59.735-41.4919,92.0818-70.56,92.0818-104.6472,0-27.6473-19.3336-48.4961-44.971-48.4961-31.4894,0-45.0233,29.2305-45.1571,29.5253a2.1428,2.1428,0,0,1-3.9071,0C111.4338,82.0474,97.8976,52.8169,66.4084,52.8169Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 145.1103,
    cy: 116.462,
    r: 6.425
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M145.1107,125.0283a8.5667,8.5667,0,1,1,8.5668-8.5668A8.5758,8.5758,0,0,1,145.1107,125.0283Zm0-12.85a4.2835,4.2835,0,1,0,4.2835,4.2833A4.2883,4.2883,0,0,0,145.1107,112.1782Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 166.1816,
    cy: 138.6041,
    r: 10.7083
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 81.9308,
    cy: 116.462,
    r: 6.425
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M81.9312,125.0283a8.5667,8.5667,0,1,1,8.5668-8.5668A8.5758,8.5758,0,0,1,81.9312,125.0283Zm0-12.85a4.2835,4.2835,0,1,0,4.2835,4.2833A4.2883,4.2883,0,0,0,81.9312,112.1782Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 60.8594,
    cy: 138.6041,
    r: 10.7083
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M113.5209,136.1519a8.5667,8.5667,0,1,1,8.5669-8.5669A8.5758,8.5758,0,0,1,113.5209,136.1519Zm0-12.85a4.2834,4.2834,0,1,0,4.2836,4.2832A4.2881,4.2881,0,0,0,113.5209,123.3018Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M69.5518,100.3582a2.1413,2.1413,0,0,1-1.8531-3.2125A14.7081,14.7081,0,0,1,87.7646,91.77a2.142,2.142,0,0,1-2.1418,3.71,10.4144,10.4144,0,0,0-14.2136,3.8076A2.142,2.142,0,0,1,69.5518,100.3582Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M157.49,100.3582a2.1419,2.1419,0,0,1-1.8574-1.0708A10.4155,10.4155,0,0,0,141.4193,95.48a2.142,2.142,0,0,1-2.1417-3.71,14.7115,14.7115,0,0,1,20.0659,5.3761,2.1427,2.1427,0,0,1-1.8531,3.2125Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M113.5209,152.295A31.7,31.7,0,0,1,91.04,142.9984a2.1414,2.1414,0,1,1,3.0285-3.0284,27.5421,27.5421,0,0,0,38.9039,0A2.1413,2.1413,0,1,1,136,142.9984,31.6949,31.6949,0,0,1,113.5209,152.295Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamePieceHeart);
export default __webpack_public_path__ + "static/media/GamePiece - Heart.1512f51849ccc02047c7b666067add31.svg";
export { ForwardRef as ReactComponent };